export const privacyOptions = [
  { label: "Public", value: "public" },
  { label: "Private", value: "private" },
];

export const enableOptions = [
  { label: "Active", value: "active" },
  { label: "In Active", value: "inactive" },
];
